const TokenKey = 'wpc_access_token'
const UserKey = 'wpc_user_id'
export function getToken () {
  return sessionStorage.getItem(TokenKey)
}

export function setToken (token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken () {
  return sessionStorage.removeItem(TokenKey)
}

export function getUserId () {
  return sessionStorage.getItem(UserKey)
}

export function setUserId (userId) {
  return sessionStorage.setItem(UserKey, userId)
}

export function removeUserId () {
  return sessionStorage.removeItem(UserKey)
}



// WEBPACK FOOTER //
// ./src/utils/authc.js